module.exports = __webpack_public_path__ + "static/media/Banner-MoP-2021.ca6c0626.jpg";